import PropTypes from 'prop-types'
import React from 'react'
import { FormattedNumber } from 'react-intl'

const isInt = num => num % 1 === 0

function FormattedCurrency({ value, round = false, currency }) {
  let minimumFractionDigits

  if (['SEK', 'DKK', 'NOK'].includes(currency)) {
    if (round) {
      value = Math.ceil(value)
    }

    if (isInt(value)) {
      minimumFractionDigits = 0
    }
  }

  return (
    <FormattedNumber
      value={value}
      currency={currency}
      style="currency"
      minimumFractionDigits={minimumFractionDigits}
    />
  )
}

export default FormattedCurrency

FormattedCurrency.propTypes = {
  value: PropTypes.number.isRequired,
  round: PropTypes.bool,
  currency: PropTypes.string.isRequired,
}
